export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";